import { SmartAccountType } from "@wallet-manager/node-types/dist/src/postgres/const";
import EnumWalletType from "@wallet-manager/node-types/dist/types/postgres/const/WalletType";
import { Dispatch, SetStateAction } from "react";
import AddressSelection from "src/components/AddressSelection";
import { Box, Typography } from "src/components/MuiGenerals";
import { useTranslation } from "src/hooks";
import { FieldsFace } from "../types/FieldsFace";

type Props = {
  chain_name: string;
  fields: FieldsFace;
  smartAccountType: SmartAccountType | undefined;
  isSecondLayerToken: boolean;
  setFields: Dispatch<SetStateAction<FieldsFace>>;
  walletMajorVersion: number;
};

const AddressSelectionColumn = (props: Props) => {
  const {
    chain_name,
    fields,
    smartAccountType,
    isSecondLayerToken,
    setFields,
    walletMajorVersion,
  } = props;

  const { t } = useTranslation("assetManagement");

  const isSmartAccount =
    smartAccountType === SmartAccountType.Kernel ||
    smartAccountType === SmartAccountType.TronRentalEnergyBandwidth;

  const getIsShow = () => {
    //is Smart account || auto resource rent selected
    if (fields.is_smart_account) {
      return false;
    }
    if (isSmartAccount) {
      return false;
    }
    if (!isSecondLayerToken) {
      return false;
    }
    return true;
  };

  return (
    <Box
      display={"grid"}
      width={"50%"}
      gridTemplateColumns={"repeat(3, 1fr)"}
      alignItems={"flex-end"}
      marginBottom={"48px"}>
      {getIsShow() && (
        <>
          <Typography
            sx={{
              gridColumnStart: "1",
              gridColumnEnd: "2",
            }}
            children={t("invoker_wallet_address")}
          />
          <Box sx={{ gridColumnStart: "2", gridColumnEnd: "4" }}>
            <AddressSelection
              chain_name={chain_name}
              setGatherAddress={(value) =>
                setFields((f) => {
                  return {
                    ...f,
                    invokerAddressDictionary: {
                      ...f.invokerAddressDictionary,
                      [walletMajorVersion]: { invokerAddress: value },
                    },
                  };
                })
              }
              tryDefaultWallet={!isSmartAccount}
              gather_address={
                fields.invokerAddressDictionary[walletMajorVersion]
                  ?.invokerAddress ?? ""
              }
              wallet_types={[EnumWalletType.InvokerWallet]}
              walletMajorVersion={walletMajorVersion}
            />
          </Box>
        </>
      )}
      <Typography
        sx={{ gridColumnStart: "1", gridColumnEnd: "2" }}
        children={t("to_address")}
      />
      <Box sx={{ gridColumnStart: "2", gridColumnEnd: "4" }}>
        <AddressSelection
          chain_name={chain_name}
          setGatherAddress={(value) =>
            setFields((f) => {
              return {
                ...f,
                receivingAddressDictionary: {
                  ...f.receivingAddressDictionary,
                  [walletMajorVersion]: { receivingAddress: value },
                },
              };
            })
          }
          isShowOwnerWalletDetails
          gather_address={
            fields.receivingAddressDictionary[walletMajorVersion]
              ?.receivingAddress ?? ""
          }
          wallet_types={[EnumWalletType.HotWallet]}
          walletMajorVersion={walletMajorVersion}
        />
      </Box>
    </Box>
  );
};
export default AddressSelectionColumn;
